<ion-item lines="none" [class]="'form-group-' + layout()">
  @if (labelKey()) {
    <ion-label class="form-label">
      {{ labelKey() | translate }}
      @if (isRequired()) {
        <span class="required-indicator" aria-label="required">*</span>
      }
    </ion-label>
  }
  <div class="form-field-wrapper">
    <ion-input
      class="form-input"
      [class.input-error]="errorMessage()"
      [type]="type()"
      [value]="internalValue()"
      [disabled]="disabled()"
      [required]="isRequired()"
      [maxlength]="maxLength()"
      [placeholder]="placeholderKey() | translate"
      label-placement="stacked"
      (ionInput)="handleInput($event)"
      (ionFocus)="handleFocus()"
      (ionBlur)="handleBlur()"
      (keydown.enter)="handleEnter()">
    </ion-input>
    <mbp-form-error [message]="errorMessage()"></mbp-form-error>
  </div>
</ion-item>
